import { render, staticRenderFns } from "./CbsObject.vue?vue&type=template&id=7effbb07&scoped=true"
import script from "./CbsObject.vue?vue&type=script&lang=js"
export * from "./CbsObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7effbb07",
  null
  
)

export default component.exports